import {ShoppingDiagnosticsData} from '../../../integrated-client/models/ShoppingDiagnosticsData'

export interface RuleNotAppliedReasonsData {
  mainText?: string | null;
  readonly bulletListItems?: Array<string> | null;
}

export interface IResultsDataLive {
  shoppingResults: ShoppingDiagnosticsData
  correlationId: string | null
  shoppingRequestDurationMs: number | null
}

export class ResultsData implements IResultsDataLive {
  shoppingResults: ShoppingDiagnosticsData
  correlationId: string | null
  shoppingRequestDurationMs: number | null

  constructor() {
    this.shoppingResults = {};
    this.correlationId = null
    this.shoppingRequestDurationMs = null
  }
}
